mobileSize = 1000;

$(document).ready(function(){
  // General Message
  $('.generalmessage').prependTo('header');

  // Google Translate
  $('#mainNavigation').removeClass('notranslate');

	$('.lang-select').click(function() {
		var theLang = $(this).attr('data-lang');
		$('.goog-te-combo').val(theLang);
		window.location = $(this).attr('href');
		location.reload();
	});

	// Weather Bug Placement
	$('#weatherBugWidget').prependTo('.socialNetworks');

	// Directions
	if ($('body').hasClass('saffireMobileSize')) {
		$('#directions').insertAfter('.map-container');
	} else {
		$('#directions').prependTo('.map-container');
	}

	// Replace Saffire Logo
	$('.saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire.png');
	
	// Email Signup Customizations
	$('.footer .emailSignupText').text("DON'T GET LEFT OUT! SIGN UP FOR UPDATES");
	$('.footer .emailSubmitButton').text('SIGN UP');

	// Header Button
	if ($('body').hasClass('saffireMobileSize')) {
		$('#headerButton').prependTo('.header-top')
	} else {
		$('#headerButton').insertAfter('#mainNavigation');
	}
});

$(window).load(function(){
	// Weather Bug
	setInterval(function(){
		var str = $('#weatherBugDescription').text();
		var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
		if (!weatherBugSet && str != '') {
			$('#weatherBugWidget').addClass('weatherBugSet');
			var findSpace = str.lastIndexOf(' ');
			var stringLength = str.length;
			var res = str.substring(findSpace, stringLength);
			var start = str.substring(0, findSpace);
			$('#weatherBugDescription').html('<span class="weatherDescriptive">' + start + '</span>' + res);
			$('#weatherBugWidget').css('visibility', 'visible');
		}
  }, 12);
  
  if ($(window).width() < 1500) {
    $('.socialNetworks').appendTo('#uc_masterPageWidgets');
  } else {
    $('.socialNetworks').appendTo('.header');
  }

  
});

$(window).resize(function(){
	// Directions
	if ($('body').hasClass('saffireMobileSize')) {
		$('#directions').insertAfter('.map-container');
		$('#directions .moreButton').text('GET DIRECTIONS');
	} else {
		$('#directions').prependTo('.map-container');
		$('#directions .moreButton').text('DIRECTIONS');
  }
  
  if ($(window).width() < 1500) {
    $('.socialNetworks').appendTo('#uc_masterPageWidgets');
  } else {
    $('.socialNetworks').appendTo('.header');
  }

	// Header Button
	if ($('body').hasClass('saffireMobileSize')) {
		$('#headerButton').prependTo('.header-top')
	} else {
		$('#headerButton').insertAfter('#mainNavigation');
	}
});